import { getSafeUrl } from "../../utils/helpers.js";
import Header from "components/Headers/Header";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import img_checked from "assets/img/userImages/check_profile.png";
import img_account from "assets/img/userImages/account.png";
import img_account2 from "assets/img/userImages/account2.png";
import img_call from "assets/img/userImages/call.png";
import cleanleftlogo from "assets/img/userImages/cleanleftlogo.png";
import img_message from "assets/img/userImages/message.png";
import { get, put } from "utils/api";
import { Spinner } from "react-bootstrap";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Badge,
  Row,
  Col,
  Card,
} from "reactstrap";

export const UserProfile = () => {
  const { userId, role } = useParams();
  const [userData, setUserData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [updatingHouseId, setUpdatingHouseId] = React.useState(null);
  const navigator = useNavigate();

  const isHomeOwner =
    userData?.userRoles?.some((r) => r.role_name === "home_owner") ?? false;

  const getFullUrl = (url) => {
    if (!url) return "";
    return getSafeUrl(url);
  };

  const previewDocument = (url) => {
    if (!url) return;
    const fullUrl = getFullUrl(url);
    const isPdf = fullUrl.toLowerCase().endsWith(".pdf");
    if (isPdf) {
      window.open(fullUrl, "_blank");
    } else {
      setSelectedImage(fullUrl);
    }
  };

  const handlePropertyStatus = (houseId, newStatus) => {
    setUpdatingHouseId(houseId);
    put(`api/admin/house/${houseId}/property-status`, { status: newStatus })
      .then(() => {
        fetchApi();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setUpdatingHouseId(null);
      });
  };

  const handleViewOrderButton = () => {
    let queryParams = new URLSearchParams();
    queryParams.set("userId", userId);
    queryParams.set("role", role);
    let queryString = queryParams.toString();
    navigator(`/user/order?${queryString}`, {
      state: { currentService: false },
    });
  };

  const fetchApi = () => {
    setIsLoading(true);
    get(`api/admin/get/userDetail`, { userId })
      .then((res) => {
        setUserData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (userId) {
      fetchApi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return (
    <>
      <Header />
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      ) : userData ? (
        <>
          <div className=" container-fluid">
            <div className="row">
              <div className="col">
                <div className="main-box mt-0">
                  <div className="content-header">
                    <h3>{`${userData?.first_name?.charAt(0).toUpperCase() +
                      userData?.first_name?.slice(1)
                      } ${userData?.last_name?.charAt(0).toUpperCase() +
                      userData?.last_name?.slice(1)
                      }`}</h3>
                  </div>
                  <div className="content-middle">
                    <div className="profile-sec">
                      <img
                        src={
                          userData?.profile_img
                            ? getSafeUrl(userData?.profile_img)
                            : cleanleftlogo
                        }
                        alt="Image_Not_Found"
                      />
                    </div>
                    <div className="profile-content">
                      <ul>
                        <li>
                          <span>
                            <img src={img_account} alt="account" />
                            Profile
                          </span>
                          {userData?.userRoles
                            .map(
                              (role) =>
                                role.role_name.charAt(0).toUpperCase() +
                                role.role_name?.slice(1)
                            )
                            .join(", ")}
                        </li>
                        <li>
                          <span>
                            <img src={img_call} alt="call" />
                            Phone No.
                          </span>
                          {userData?.phone_number}
                        </li>
                        <li>
                          <span>
                            <img src={img_account2} alt="account2" />
                            Account Formation Date
                          </span>
                          {`${new Date(userData?.createdAt).toLocaleDateString(
                            "en-US"
                          )}`}
                        </li>
                        <li>
                          <span>
                            <img src={img_message} alt="message" />
                            Email Address
                          </span>
                          <>
                            {userData?.email}
                            {userData?.is_email_verified ? (
                              <img
                                src={img_checked}
                                alt="approve"
                                className="img_checked"
                              />
                            ) : null}
                          </>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* ── House Documents Section (home_owner only) ── */}
                {isHomeOwner &&
                  userData?.houseDocuments && (
                    <div className="main-box mt-4">
                      <div className="box-header">
                        <h4 className="m-2">House Documents</h4>
                      </div>

                      {userData.houseDocuments.map((house, houseIdx) => (
                        <div key={house.houseId} className="px-3 pt-3 pb-1">
                          {/* Property header */}
                          <div
                            style={{
                              background: "#f6f9fc",
                              borderLeft: "4px solid #5e72e4",
                              borderRadius: "4px",
                              padding: "10px 14px",
                              marginBottom: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            {/* Left: thumbnail + name + address */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              {house.houseImages && house.houseImages[0]?.imageUrl ? (
                                <img
                                  src={getFullUrl(house.houseImages[0].imageUrl)}
                                  alt={house.houseName}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    border: "1px solid #dee2e6",
                                    flexShrink: 0,
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "6px",
                                    background: "#e9ecef",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  <i className="fas fa-home text-muted" style={{ fontSize: "16px" }} />
                                </div>
                              )}
                              <div>
                                <h6
                                  className="mb-0 font-weight-bold text-uppercase"
                                  style={{ color: "#32325d", fontSize: "0.8rem" }}
                                >
                                  {house.houseName}
                                </h6>
                                <small className="text-muted">
                                  <i className="fas fa-map-marker-alt mr-1" />
                                  {house.houseAddress}
                                </small>
                              </div>
                            </div>

                            {/* Right: status badge + toggle button */}
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <Badge
                                color={house.property_status === "active" ? "success" : "danger"}
                                pill
                                style={{ fontSize: "0.72rem" }}
                              >
                                <i
                                  className={`fas ${
                                    house.property_status === "active"
                                      ? "fa-check-circle"
                                      : "fa-ban"
                                  } mr-1`}
                                />
                                {house.property_status === "active" ? "Active" : "Suspended"}
                              </Badge>
                              <Button
                                color={house.property_status === "active" ? "danger" : "success"}
                                size="sm"
                                disabled={updatingHouseId === house.houseId}
                                onClick={() =>
                                  handlePropertyStatus(
                                    house.houseId,
                                    house.property_status === "active" ? "suspended" : "active"
                                  )
                                }
                              >
                                {updatingHouseId === house.houseId ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm mr-1"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                    Updating...
                                  </>
                                ) : house.property_status === "active" ? (
                                  <>
                                    <i className="fas fa-ban mr-1" />
                                    Suspend
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-check-circle mr-1" />
                                    Activate
                                  </>
                                )}
                              </Button>
                            </div>
                          </div>

                          {house.documents && house.documents.length > 0 ? (
                            <div className="table-responsive mb-3">
                              <table className="table table-bordered table-hover align-items-center mb-0" style={{ fontSize: "0.875rem" }}>
                                <thead className="thead-light">
                                  <tr>
                                    <th style={{ width: "50px" }}>#</th>
                                    <th>Document Name</th>
                                    <th style={{ width: "130px" }}>Type</th>
                                    <th style={{ width: "160px" }} className="text-center">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {house.documents.map((doc, idx) => {
                                    const fullUrl = getFullUrl(doc.imageUrl);
                                    const isPdf = fullUrl.toLowerCase().endsWith(".pdf");
                                    const fileName =
                                      doc.name ||
                                      doc.imageUrl?.split("/").pop() ||
                                      `Document ${idx + 1}`;

                                    return (
                                      <tr key={doc.id}>
                                        <td className="text-muted">{idx + 1}</td>
                                        <td>
                                          <span
                                            title={fileName}
                                            style={{
                                              display: "inline-block",
                                              maxWidth: "340px",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {fileName}
                                          </span>
                                        </td>
                                        <td>
                                          {isPdf ? (
                                            <Badge color="danger" pill>
                                              <i className="fas fa-file-pdf mr-1" />
                                              PDF
                                            </Badge>
                                          ) : (
                                            <Badge color="primary" pill>
                                              <i className="fas fa-file-image mr-1" />
                                              Image
                                            </Badge>
                                          )}
                                        </td>
                                        <td className="text-center">
                                          <Button
                                            color="info"
                                            outline
                                            size="sm"
                                            className="mr-2"
                                            onClick={() => previewDocument(doc.imageUrl)}
                                          >
                                            <i className="fas fa-eye mr-1" />
                                            View
                                          </Button>
                                          <a
                                            href={fullUrl}
                                            download={fileName}
                                            className="btn btn-outline-secondary btn-sm"
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            <i className="fas fa-download mr-1" />
                                            Download
                                          </a>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <p className="text-muted small mb-3">
                              <i className="fas fa-info-circle mr-1" />
                              No documents uploaded for this property.
                            </p>
                          )}

                          {houseIdx < userData.houseDocuments.length - 1 && (
                            <hr className="my-2" />
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                <div className="main-box mt-4 mb-4">
                  <div className="box-header">
                    <div className="dual-btn">
                      <button
                        className="navbar-toggler"
                        type="button"
                        onClick={() => {
                          window.history.back();
                        }}
                      >
                        Go Back{" "}
                      </button>
                      <button
                        className="navbar-toggler"
                        type="button"
                        onClick={() => {
                          handleViewOrderButton();
                        }}
                      >
                        View Order History{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Image Preview Modal ── */}
          <Modal
            isOpen={!!selectedImage}
            toggle={() => setSelectedImage(null)}
            centered
            size="lg"
            backdropClassName="modal-backdrop-blur"
          >
            <ModalHeader toggle={() => setSelectedImage(null)}>
              Document Preview
            </ModalHeader>
            <ModalBody className="text-center p-0">
              <img
                src={selectedImage}
                alt="Preview"
                style={{ maxWidth: "100%", maxHeight: "80vh" }}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => setSelectedImage(null)}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
        </>
      ) : (
        <p>Data not found</p>
      )}
    </>
  );
};
